import _ from 'lodash'

const createRequestLimiter = (maxInFlight: number) => {
  let inFlight = 0
  const waiting: Array<() => void> = []

  const acquire = (signal?: AbortSignal) =>
    new Promise<void>((resolve, reject) => {
      if (signal?.aborted) {
        reject(signal.reason)
        return
      }
      if (inFlight < maxInFlight) {
        inFlight++
        resolve()
        return
      }
      const onAbort = () => {
        _.pull(waiting, start)
        reject(signal?.reason)
      }
      const start = () => {
        signal?.removeEventListener('abort', onAbort)
        inFlight++
        resolve()
      }
      waiting.push(start)
      signal?.addEventListener('abort', onAbort, { once: true })
    })

  return async <T>(task: () => Promise<T>, signal?: AbortSignal): Promise<T> => {
    await acquire(signal)
    try {
      return await task()
    } finally {
      inFlight--
      waiting.shift()?.()
    }
  }
}

// Per-row org list badges: a page of 25-100 parallel calls cold-starts one Lambda per row
export const limitBadgeRequest = createRequestLimiter(10)
